import { render, staticRenderFns } from "./ToggleInactiveUsersButton.vue?vue&type=template&id=98f07d82&"
import script from "./ToggleInactiveUsersButton.vue?vue&type=script&lang=ts&"
export * from "./ToggleInactiveUsersButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports